import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageView',
  props: {
		css: {
			type: String,
			default: "",
		},
		src: {
			type: String,
			default: "/media/images/airplane.jpg",
		},
	},
  setup(__props) {

	

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    style: _normalizeStyle({
			backgroundImage: 'url(' + __props.src + ')',
			backgroundSize: 'cover',
			backgroundPosition: 'center',
		}),
    class: _normalizeClass([
			__props.css,
			{
				'bg-no-repeat': true,
			},
		])
  }, null, 6))
}
}

})